export default {
    'ERROR-GET-REVIEW-INTEGRATIONS': {
        'REVIEW-INTEGRATION-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Intégration d'avis non trouvée.",
                en: 'Review integration not found.',
            },
            redirectPath: '/review-integrations-not-found',
        },
    },
    'ERROR-CREATE-REVIEW-INTEGRATION': {
        'REVIEW-INTEGRATION-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Impossible de trouver l'intégration d'avis spécifiée pour la création.",
                en: 'Unable to find the specified review integration for creation.',
            },
        },
        'VALIDATION-ERROR': {
            actionType: 'toast',
            message: {
                fr: "Les données fournies pour la création de l'intégration d'avis sont invalides.",
                en: 'The data provided for creating the review integration is invalid.',
            },
        },
    },
    'ERROR-UPDATE-REVIEW-INTEGRATION': {
        'REVIEW-INTEGRATION-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Intégration d'avis non trouvée pour la mise à jour.",
                en: 'Review integration not found for update.',
            },
        },
        'VALIDATION-ERROR': {
            actionType: 'toast',
            message: {
                fr: "Les données fournies pour la mise à jour de l'intégration d'avis sont invalides.",
                en: 'The data provided for updating the review integration is invalid.',
            },
        },
    },
    'ERROR-DELETE-REVIEW-INTEGRATION': {
        'REVIEW-INTEGRATION-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Intégration d'avis non trouvée pour suppression.",
                en: 'Review integration not found for deletion.',
            },
        },
        'DELETION-ERROR': {
            actionType: 'toast',
            message: {
                fr: "Une erreur s'est produite lors de la suppression de l'intégration d'avis.",
                en: 'An error occurred while deleting the review integration.',
            },
        },
    },
};
